module.exports = __webpack_public_path__ + "static/media/lizinde_kagarama9.579f5c35.jpeg";